export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}file/file`;
    return $resource(baseUrl, null, {
        list: {
            method: 'GET',
            url: `${baseUrl}/list`,
            isArray: true
        },
        attach: {
            method: 'POST',
            url: `${baseUrl}/attach`
        },
        detach: {
            method: 'POST',
            url: `${baseUrl}/detach`
        },
        entityFiles: {
            method: 'GET',
            url: `${baseUrl}/entity-files`,
            isArray: true
        },
        deleteFile: {
            method: 'DELETE',
            url: `${baseUrl}/:hash`,
            params: { hash: '@hash' },
            hasBody: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/File/index.js